import React, { useState, createElement } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import { generateSalesSessionDownloadEndpoint } from '../../config/endpoints';

const ContentComponent = ({ contentComponent }) => {
  if (!contentComponent) {
    return null;
  }

  return contentComponent;
};

ContentComponent.propTypes = {
  contentComponent: PropTypes.node,
};

ContentComponent.defaultProps = {
  contentComponent: undefined,
};

const CollapsibleHeader = (props) => {
  const [showContent, setShowContent] = useState(false);

  const {
    headerFont,
    headerText,
    component,
    downloadButton,
    salesSessionId,
    downloadEndpoint,
    downloadLabel,
  } = props;

  const toggle = () => setShowContent((prev) => !prev);

  const toolbar = downloadButton && salesSessionId && (
    <ButtonToolbar className="pull-right">
      <a
        className="btn btn-secondary"
        href={
          downloadEndpoint
            ? downloadEndpoint(salesSessionId)
            : generateSalesSessionDownloadEndpoint(salesSessionId)
        }
      >
        {downloadLabel}
      </a>
    </ButtonToolbar>
  );

  const iconType = showContent ? 'minus' : 'plus';

  const contentComponent = showContent ? createElement(component, props) : null;

  return (
    <>
      {toolbar}

      <div className="flex">
        <h2 className={headerFont}>
          {headerText}{' '}
          <i
            onClick={toggle}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggle();
              }
            }}
            role="button"
            tabIndex={0}
            className={`fa fa-${iconType}-square-o text-primary clickable`}
          />
        </h2>
      </div>

      <ContentComponent contentComponent={contentComponent} />
    </>
  );
};

CollapsibleHeader.propTypes = {
  headerText: PropTypes.string.isRequired,
  component: PropTypes.func.isRequired,
  headerFont: PropTypes.string,
  downloadButton: PropTypes.bool,
  salesSessionId: PropTypes.number,
  downloadEndpoint: PropTypes.func,
  downloadLabel: PropTypes.string,
};

CollapsibleHeader.defaultProps = {
  downloadButton: false,
  salesSessionId: null,
  headerFont: 'h2',
  downloadEndpoint: null,
  downloadLabel: 'Descargar boletos',
};

export default CollapsibleHeader;
